import * as z from "zod/v4";

export const archiveAeoPrompts = {
  name: "archiveAeoPrompts" as const,
  input: z.object({ promptIds: z.array(z.bigint()).min(1) }),
  output: z.object({ success: z.boolean(), archivedCount: z.number() }),
};
